import Invoices from './Invoices';
export { default as InvoicesContent } from './InvoicesContent';
export { default as Invoice } from './Invoice';

export default Invoices;
